import axios from "axios";
import {
  ASSIGN_WORKFLOW_TO_ENTITY_TYPE_TEMPLATE,
  GET_WORKFLOW_ASSIGNED_TO_TEMPLATE,
  LIST_WORFLOWS,
} from "@/utils/constants/constants.js";

export default {
  methods: {
    async view_signing_workflow() {
      try {
        const response = await axios.post(
          LIST_WORFLOWS,
          {},
          { headers: this.headers, params: { project_id: this.project_id } }
        );

        this.workflows = (response.data?.workflows || []).map(workflow => ({
          id: workflow.id,
          name: workflow.name,
          description: workflow.description || "",
        }));
        this.workflows_table_headers = this.workflows.length ? Object.keys(this.workflows[0]) : [];
      } catch (error) {
        const message = error.response?.data?.message || error.response?.data?.detail || error.message;
        this.show_error(`Error fetching workflows: ${message}`);
      }
    },
    select_entity_type_template(template_document_entity_type_id) {
      this.assigned_workflow = [];
      this.template_document_entity_type_id = template_document_entity_type_id;

      axios
        .post(
          GET_WORKFLOW_ASSIGNED_TO_TEMPLATE,
          { template_document_entity_type_id: this.template_document_entity_type_id },
          { headers: this.headers }
        )
        .then(response => {
          if (Array.isArray(response.data?.data)) {
            this.assigned_workflow = response.data.data.map(item => item.workflow);
          }
        })
        .catch(() => {
          this.show_error("Error fetching assigned workflow");
        });
    },
    toggle_assignment(workflow_id) {
      const payload = {
        template_document_entity_type_id: this.template_document_entity_type_id,
        workflow_id,
        is_assigned: !this.assigned_workflow.includes(workflow_id),
      };

      axios
        .post(ASSIGN_WORKFLOW_TO_ENTITY_TYPE_TEMPLATE, payload, { headers: this.headers })
        .then(() => {
          if (payload.is_assigned) {
            this.assigned_workflow = [workflow_id];
          } else {
            this.assigned_workflow = this.assigned_workflow.filter(id => id !== workflow_id);
          }
        })
        .catch(() => {
          this.show_error("Error updating workflow assignment");
        });
    },
  },
};
